<template>
	<div>
		<b-modal
			id="detail-modal"
			header-class="bg-sinarmas"
			size="xl"
			ref="bootstrapModal"
			@hide="closeDetail"
			no-close-on-backdrop
			hide-footer
		>
			<template v-slot:modal-header="{ close }">
				<div class="w-100 d-flex align-items-center justify-content-between">
					<span class="text-white font-weight-bold">{{ detail.VENDOR_NAME }}</span>

					<a @click.prevent="close" href="javascript:void(0);" class="btn btn-transparent"><i class="material-icons font-weight-bold text-white" style="font-size: 18px; vertical-align: middle;">close</i></a>
				</div>
			</template>

	    <div class="buttons-container">
	    	<div class="content">
	    			<b-button
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'information' ? 'active' : ''"
			    		@click="setCurrentTab('information')"
			    	>
			    		Information
			    	</b-button>

			    	<b-button
							v-if="$store.state.currentUser"
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'po_released' ? 'active' : ''"
			    		@click="setCurrentTab('po_released')"
			    	>
			    		PO Released
			    	</b-button>

			    	<b-button
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'legal_documents' ? 'active' : ''"
			    		@click="setCurrentTab('legal_documents')"
			    	>
			    		Legal Documents
			    	</b-button>

			    	<b-button
							v-if="$store.state.currentUser"
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'total_event' ? 'active' : ''"
			    		@click="setCurrentTab('total_event')"
			    	>
			    		Total Event
			    	</b-button>

			    	<b-button
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'k3l_assessment' ? 'active' : ''"
			    		@click="setCurrentTab('k3l_assessment')"
			    	>
			    		K3L Assessment
			    	</b-button>

			    	<b-button
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'spm_scoring' ? 'active' : ''"
			    		@click="setCurrentTab('spm_scoring')"
			    	>
			    		SPM Scoring
			    	</b-button>

			    	<b-button
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'sio' ? 'active' : ''"
			    		@click="setCurrentTab('sio')"
			    	>
			    		SIO - Surat Ijin Operasi
			    	</b-button>

			    	<b-button
							v-if="$store.state.currentUser"
			    		class="mr-1 bg-tabdetail"
			    		:class="$store.state.activeTab === 'csi_scoring' ? 'active' : ''"
			    		@click="setCurrentTab('csi_scoring')"
			    	>
			    		CSI Scoring
			    	</b-button>
	    	</div>
	    </div>

			<div v-if="$store.state.datatable.modalLoading" class="d-flex justify-content-center align-items-center">
				<b-spinner large variant="primary"/>
			</div>

	    <div class="w-100 pt-3" v-if="$store.state.datatable.detail">
	    	<transition name="component-fade" mode="out-in">
	    		<keep-alive>
		    		<component :is="activeTab" />
		    	</keep-alive>
	    	</transition>
	    </div>
	  </b-modal>
	</div>
</template>

<script>
export default {
	name: 'Detail',
	data() {
		return {
			showCarousel: false,
			currentSliderPage: 0,
		}
	},
	computed: {
		detail() {
			const self = this
			if(self.$store.state.datatable.detail){
				return self.$store.state.datatable.detail
			}
			return ''
		},
		activeTab() {
			const tab = this.$store.state.activeTab

			switch (tab) {
				case 'information':
					return () => import('@/components/Details/Information')
					break
				case 'po_released':
					return () => import('@/components/Details/POReleased')
					break
				case 'legal_documents':
					return () => import('@/components/Details/LegalDocument')
					break
				case 'total_event':
					return () => import('@/components/Details/TotalEvent')
					break
				case 'k3l_assessment':
					return () => import('@/components/Details/K3lAssessment')
					break
				case 'spm_scoring':
					return () => import('@/components/Details/SpmScoring')
					break
				case 'sio':
					return () => import('@/components/Details/sio')
					break
				default:
					return () => import('@/components/Details/CsiScoring')
			}
		}
	},
	methods: {
		closeDetail() {
			this.$store.dispatch('setCurrentTab', 'information')
			this.setCurrentTab('information')
		},
		setCurrentTab(tab) {
			this.$store.dispatch('setCurrentTab', tab)
		},
		previous() {
			this.currentSliderPage = 0
		},
		next() {
			this.currentSliderPage = 1
		}
	},
}
</script>

<style lang="scss">
@import "~/assets/scss/components/detail.scss";
</style>
